<template>
  <b-navbar-nav id="menu">
    <router-link tag="li" to="/device" class="nav-item">
      <a class="nav-link">
        <div>
          <font-awesome-icon class="icon" icon="sign" />
          <p>Mes supports</p>
        </div>
      </a>
    </router-link>
    <router-link tag="li" to="/reports" class="nav-item">
      <a class="nav-link">
        <div>
          <font-awesome-icon class="icon" icon="file-signature" />
          <p>Je déclare</p>
        </div>
      </a>
    </router-link>
    <router-link tag="li" to="/report-history" class="nav-item">
      <a class="nav-link">
        <div>
          <font-awesome-icon class="icon" icon="history" />
          <p>Mes déclarations</p>
        </div>
      </a>
    </router-link>
    <router-link tag="li" to="/documents" class="nav-item">
      <a class="nav-link">
        <div>
          <font-awesome-icon class="icon" icon="folder" />
          <p>Mes documents</p>
        </div>
      </a>
    </router-link>
  </b-navbar-nav>
</template>

<script>
export default {
  name: 'app-navbar-menu',
};
</script>

<style scoped>
/* IE10+ CSS styles */
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .nav-item {
    min-width: 180px;
    cursor: pointer;
  }

  a.nav-link > div {
    display: block !important;
  }
}
</style>
